/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import React, {Fragment, useEffect, useRef, useState} from 'react'
import {Dialog, Menu, Transition} from '@headlessui/react'
import {
    Bars3Icon,
    BellIcon,
    CalendarIcon,
    ChartPieIcon,
    Cog6ToothIcon,
    DocumentDuplicateIcon,
    FolderIcon,
    HomeIcon,
    UsersIcon,
    XMarkIcon,
    WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline'
import {ChevronDownIcon, MagnifyingGlassIcon} from '@heroicons/react/20/solid'
import {useLoaderData, useLocation} from "react-router-dom";
import axios from "axios";
import {fastSearchCard, isUrlValid, smallEventCard} from "../common/utilities";
import {ArrowLongLeftIcon, ArrowLongRightIcon, ChevronDoubleLeftIcon} from "@heroicons/react/16/solid";
import {useTranslation} from "react-i18next";

const navigation = [{name: 'Dashboard', href: '/dashboard', icon: HomeIcon, current: true}, {
    name: 'NLP', href: '/nlpdash', icon: WrenchScrewdriverIcon, current: false
}, {
    name: 'Import', href: '/import', icon: CalendarIcon, current: false
},]
const teams = [{id: 1, name: 'Heroicons', href: '#', initial: 'H', current: false}, {
    id: 2, name: 'Tailwind Labs', href: '#', initial: 'T', current: false
}, {id: 3, name: 'Workcation', href: '#', initial: 'W', current: false},]
const userNavigation = [{name: 'Your profile', href: '#'}, {name: 'Sign out', href: '#'},]

function classNames(...classes)
{
    return classes.filter(Boolean).join(' ')
}

export default function Searchsidebar({buttontype,initialQuery}) {
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const loaderdata = useLoaderData() as any;
    const location = useLocation();
    const [addingEvent, setAddingEvent] = useState(false)
    const [searchResults, setSearchResults] = useState<any[]>([])
    const [query, setQuery] = useState('');
    const [importSidebarString, setImportSidebarString] = useState('');
    const [searching, setSearching] = useState(false);
    const [totalResults, setTotalResults] = useState(0);
    const [attractionName, setAttractionName] = useState('');
    const [nextOffset, setNextOffset] = useState("");
    const [previousOffset, setPreviousOffset] = useState("");
    const [cancel, setCancel] = useState(null);

    const { t, i18n }:any = useTranslation('manageuser');


    const data = useLoaderData() as any;
    if(data)
    {
        if(data.name !== localStorage.getItem('username'))
        {
            localStorage.setItem('username', data.name);
        }
    }

    useEffect(() => {
        if(initialQuery)
        {
            handleInitialQuery()
        }
    }, []);



    let cancelToken;
    let buttonType = buttontype;

    const handlePaste = event => {
        var eventurl = event.clipboardData.getData('text');
        setImportSidebarString(eventurl);
        setAddingEvent(true)
        if (!isUrlValid(eventurl))
        {
            alert("Invalid URL");
            setImportSidebarString('')
            setAddingEvent(false)
            return;
        }
        else
        {
            axios.post(`${process.env.REACT_APP_API_URL}/p/api/event/import.do`, {
                eventurl: eventurl, ticket: localStorage.getItem('ticket')
            }, {
                           headers: {
                               'Content-Type': 'application/x-www-form-urlencoded'
                           }
                       }).then(function (response) {
                // handle success
                setAddingEvent(false)
                setImportSidebarString('')
                console.log('importSidebarString', importSidebarString)
            }).catch(function (error) {
                // handle error
                console.log(error);
                setAddingEvent(false)

            });
        }
    };

    const handleInitialQuery = async () => {

        const searchTerm = initialQuery
        if(searchTerm.length < 1)
        {
            setSearchResults([]);
            setQuery(searchTerm)
            setSearching(false)
            return;
        }
        setQuery(searchTerm)
        setSearching(true)

        //Check if there are any previous pending requests

        if (cancel)
        {
            cancel.cancel("Operation canceled due to new request.")
        }

        cancelToken = axios.CancelToken.source()
        setCancel(cancelToken);


        try
        {

            const results = await axios.get(`${process.env.REACT_APP_API_URL}/p/ajax/search.do?both=true&q=${searchTerm}`,

                                            {cancelToken: cancelToken.token} //Pass the cancel token to the current request

            )

            setSearchResults(results.data.collection);
            setNextOffset(results.data.pagination.nextOffset);
            setPreviousOffset(results.data.pagination.previousOffset);
            setTotalResults(results.data.pagination.totalResults);
            setSearching(false)

            console.log("Results for " + searchTerm + ": ", results.data)

        }
        catch (error)
        {
            if(error.name && error.name !== 'CanceledError')
            {
                console.log(error)
            }

        }
    }



    const handleSearchChange = async (e) => {

        const searchTerm = e.target.value
        if(searchTerm.length < 1)
        {
            setSearchResults([]);
            setQuery(searchTerm)
            setSearching(false)
            return;
        }
        setQuery(searchTerm)
        setSearching(true)

        //Check if there are any previous pending requests

        if (cancel)
        {
            cancel.cancel("Operation canceled due to new request.")
        }

        cancelToken = axios.CancelToken.source()
        setCancel(cancelToken);


        try
        {

            const results = await axios.get(`${process.env.REACT_APP_API_URL}/p/ajax/search.do?both=true&q=${searchTerm}`,

                                            {cancelToken: cancelToken.token} //Pass the cancel token to the current request

            )

            setSearchResults(results.data.collection);
            setNextOffset(results.data.pagination.nextOffset);
            setPreviousOffset(results.data.pagination.previousOffset);
            setTotalResults(results.data.pagination.totalResults);
            setSearching(false)

            console.log("Results for " + searchTerm + ": ", results.data)

        }
        catch (error)
        {
            if(error.name && error.name !== 'CanceledError')
            {
                console.log(error)
            }

        }
    }

    const getMore = async (offset) => {

        setSearching(true)

        //Check if there are any previous pending requests

        if (cancel)
        {
            cancel.cancel("Operation canceled due to new request.")
        }

        cancelToken = axios.CancelToken.source()
        setCancel(cancelToken);


        try
        {

            const results = await axios.get(`${process.env.REACT_APP_API_URL}/p/ajax/search.do?both=true&q=${query}&offset=${offset}`,

                                            {cancelToken: cancelToken.token} //Pass the cancel token to the current request

            )

            setSearchResults(results.data.collection);
            setNextOffset(results.data.pagination.nextOffset);
            setPreviousOffset(results.data.pagination.previousOffset);
            setTotalResults(results.data.pagination.totalResults);
            setSearching(false)

            console.log("More Results for " + query + ": ", results.data)

        }
        catch (error)
        {
            if(error.name && error.name !== 'CanceledError')
            {
                console.log(error)
            }

        }
    }

    const getNext = () => {
        getMore(nextOffset);
    }
    const getPrevious = () => {
        getMore(previousOffset);
    }

    const getFirst = () => {
        getMore(0);

    }


    return (<>


            <div className="mx-auto max-w-7xl px-6 mt-4 self-stretch mt-4 mb-4 border border-gray-200 rounded p-3">
                <form className="relative flex flex-1" action="#" method="GET">
                    <label htmlFor="search-field" className="sr-only">
                        Search
                    </label>
                    <MagnifyingGlassIcon
                        className="pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-gray-400"
                        aria-hidden="true"
                    />
                    <input
                        id="search-field"
                        className="block h-full w-full border-0 py-0 pl-8 pr-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm"
                        placeholder="Search..."
                        defaultValue={initialQuery}
                        type="search"
                        name="search"
                        onChange={e => handleSearchChange(e)}
                    />

                </form>
            </div>
            <ul>
                {searching && <li className="p-4 text-gray-800 flex justify-center">
                    <div className={'text-pg_yellow'}><i
                            className="fa-2x fa-duotone fa-loader fa-spin"></i></div>
                </li>}
                {searchResults && searchResults.length > 0 && searchResults.map((result) => (fastSearchCard(result,buttonType)))}
            </ul>
        {searchResults && searchResults.length > 0 && <nav
                className="flex items-center justify-between border-t border-gray-200 px-4 py-2 sm:px-0  mt-2 mb-2 mr-4 ml-4"
                id={'topnav'}>
            <div className="-mt-px flex w-0 flex-1">
                <div
                        onClick={() => getFirst()}
                        className="cursor-pointer inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-900 hover:border-blue-300 hover:text-gray-700"
                >
                    <ChevronDoubleLeftIcon className="mr-3 h-5 w-5 text-gray-900"
                                           aria-hidden="true"/>

                </div>
            </div>
            <div className="flex">

                <div
                        onClick={() => getPrevious()}
                        className="cursor-pointer inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-900 hover:border-gray-300 hover:text-gray-700"
                >
                    <ArrowLongLeftIcon className="mr-3 h-5 w-5 text-gray-900"
                                       aria-hidden="true"/>
                </div>
                <div
                        onClick={() => getNext()}
                        className="cursor-pointer inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-900 hover:border-gray-300 hover:text-gray-700"
                >
                    <ArrowLongRightIcon className="ml-3 h-5 w-5 text-gray-900"
                                        aria-hidden="true"/>
                </div>
            </div>
            <div className="-mt-px flex w-0 flex-1 justify-end">

            </div>
        </nav>}


    </>)
}
